import './Header.scss';

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { type RefineThemedLayoutHeaderProps } from '@refinedev/antd';
import { Button, Flex, Layout as AntdLayout } from 'antd';
import React from 'react';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { useUiContext } from '@/contexts/UiContext';
import { useUserContext } from '@/contexts/UserContext';
import { UserWorkAreaString } from '@/model/General/UserWorkArea';

import CountrySelector from './CountrySelector';
import HeaderNotifications from './HeaderNotifications';
import UserMenuIcon from './UserMenuIcon';

const Header: React.FC<RefineThemedLayoutHeaderProps> = () => {
  const { openSider, setOpenSider, isMediumScreen, isMobile } = useUiContext();
  const { userLogged, devOptions, canChangeCountry } = useUserContext();

  return (
    <AntdLayout.Header className="LayoutHeader">
      {isMediumScreen && (
        <div className="LayoutHeaderMobileTrigger">
          <Button
            className="LayoutHeaderMobileTriggerButton"
            type="text"
            icon={openSider ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setOpenSider(!openSider)}
          />
        </div>
      )}
      <Flex gap={16} align="center" justify="end">
        {!isMobile && devOptions && (
          <AntdSelect
            size="small"
            value={devOptions.selectedWorkArea}
            onChange={devOptions.handleChangeWorkArea}
            options={Object.keys(UserWorkAreaString).map(v => ({
              label: UserWorkAreaString[v as keyof typeof UserWorkAreaString],
              value: v,
            }))}
          />
        )}
        {!isMediumScreen && canChangeCountry && <CountrySelector />}
        <HeaderNotifications />
        <UserMenuIcon user={userLogged} />
      </Flex>
    </AntdLayout.Header>
  );
};

export default Header;
